import { topicsData } from '@/mocks/home';

const tagStyles: Record<string, string> = {
  hot: 'bg-primary-100 text-primary-700',
  trending: 'bg-accent-100 text-accent-800',
  new: 'bg-green-100 text-green-700',
  normal: 'bg-background-200 text-foreground-600',
};

const tagLabels: Record<string, string> = {
  hot: '热门',
  trending: '趋势',
  new: '新晋',
  normal: '活跃',
};

export default function Topics() {
  return (
    <section id="topics" className="py-14 md:py-20 bg-background-100">
      <div className="max-w-[1400px] mx-auto px-4 md:px-6">
        <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950 text-center mb-3">
          热门话题
        </h2>
        <p className="text-sm text-foreground-500 text-center mb-10">当前全网讨论度最高的话题标签</p>
        <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-5 gap-3">
          {topicsData.map((topic, i) => (
            <a
              key={i}
              href="#topics"
              className="group bg-background-50 rounded-lg p-4 border border-background-200/70 hover:border-primary-300 transition-all duration-200 cursor-pointer"
            >
              <div className="flex items-center gap-2 mb-2">
                <span className="w-7 h-7 flex items-center justify-center bg-primary-100 rounded-md">
                  <i className={`${topic.icon} text-primary-600 text-sm`}></i>
                </span>
                <span className={`text-[10px] font-bold px-1.5 py-0.5 rounded ${tagStyles[topic.tag]}`}>
                  {tagLabels[topic.tag]}
                </span>
              </div>
              <p className="text-sm font-medium text-foreground-900 group-hover:text-primary-600 transition-colors whitespace-nowrap overflow-hidden text-ellipsis">
                {topic.name}
              </p>
              <p className="text-xs text-foreground-500 mt-1">热度 {topic.heat}</p>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}